export function createProjectApi(baseUrl) {
  return {
    project: {
      getProject: (id) => `${baseUrl}/v2/projects/${id}/`,
      getDocuments: (id) => `${baseUrl}/v2/projects/${id}/files/`,
      getParticipants: `${baseUrl}/v2/participants/`,
      appLink: (id) => `${baseUrl}/v1/projects/${id}/links/`,
    },
  };
}
